import { render, staticRenderFns } from "./InspectionListAttachmentsAddButton.vue?vue&type=template&id=5706208e&scoped=true"
import script from "./InspectionListAttachmentsAddButton.vue?vue&type=script&lang=ts"
export * from "./InspectionListAttachmentsAddButton.vue?vue&type=script&lang=ts"
import style0 from "./InspectionListAttachmentsAddButton.vue?vue&type=style&index=0&id=5706208e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5706208e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VHover,VIcon,VOverlay,VProgressCircular})
